import { FC } from "react";
import { useSelector } from "react-redux";

import { DesignToken, ModalPortal, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import ConfirmActionModal from "components/modals/ConfirmActionModal";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'ConfirmModal' is declared but its value is never ... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ConfirmModal } from "components/modals/new/ConfirmModal";
import { selectReplyAddresses } from "store/entities/reply-addresses/selectors";
import { selectTeamsAlphabetically } from "store/entities/teams";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

interface IProps {
  onDomainDelete: (domainId: string) => void;
  onClose: () => void;
  domainId: string;
}

const DeleteDomainModal: FC<IProps> = ({ onDomainDelete, onClose, domainId }) => {
  const replyAddresses = Object.values(useSelector(selectReplyAddresses));
  const teams = useSelector(selectTeamsAlphabetically);

  const replyAddressesUsingDomain = replyAddresses
    .filter(replyAddress => replyAddress.emailDomainID === domainId)
    .map(replyAddress => ({
      ...replyAddress,
      displayName: teams.find(team => team.replyAddressID === replyAddress.id)?.replyName,
    }));

  const handleDomainDelete = (): void => onDomainDelete(domainId);
  const domainDeletionBlocked = replyAddressesUsingDomain.length > 0;

  return (
    <ModalPortal zIndex={StackingContextLevel.Modal}>
      <ConfirmActionModal
        heading="Delete domain?"
        onClose={onClose}
        primaryAction={{
          label: "Delete",
          onClick: handleDomainDelete,
          actionType: "destructive",
          dataTestId: "delete-domain-button",
          disabled: domainDeletionBlocked,
        }}
        secondaryAction={{
          label: "Cancel",
          onClick: onClose,
          dataTestId: "cancel-delete-domain-button",
        }}
      >
        {domainDeletionBlocked ? (
          <>
            <Text>You cannot delete this domain. It&lsquo;s used in the following reply addresses:</Text>
            <ul>
              {replyAddressesUsingDomain.map(replyAddress => (
                <li key={replyAddress.id}>
                  <Flex justifyContent="center" gap={withVar(SpacingToken.Spacing1)}>
                    <Text bold>{replyAddress.email}</Text>
                    <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
                      ({replyAddress.displayName || "display name not set"})
                    </Text>
                  </Flex>
                </li>
              ))}
            </ul>
            <Text>Remove these reply addresses and try again.</Text>
          </>
        ) : (
          <Text>Are you sure you want to delete this domain?</Text>
        )}
      </ConfirmActionModal>
    </ModalPortal>
  );
};

export default DeleteDomainModal;
